// extracted by mini-css-extract-plugin
export default {"cell-tooltip-view":"CellTooltipView_cell-tooltip-view__PhHid"};